import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import AnimatedPage from '../components/AnimatedPage';
import {
  FlaskConical,
  Scale,
  Pill,
  CreditCard,
  Car,
  FileText,
  ArrowRight,
  CheckCircle2,
  ExternalLink
} from 'lucide-react';

const Services = () => {
  const services = [
    {
      icon: FlaskConical,
      title: 'Cancer Blood Marker Testing',
      description: 'Advanced diagnostic testing to detect cancer markers early, enabling proactive monitoring and intervention strategies.',
      color: 'from-purple-50 to-fuchsia-50',
      iconColor: 'text-purple-600'
    },
    {
      icon: Scale,
      title: 'Medically Supervised Weight Management',
      description: 'Personalized weight management programs designed and monitored by medical professionals for safe, effective results.',
      color: 'from-stone-50 to-stone-50',
      iconColor: 'text-stone-600'
    },
    {
      icon: Pill,
      title: 'Supplement Support via Fullscript',
      description: 'Access to high-quality supplements through our professional-grade dispensary with personalized recommendations.',
      color: 'from-amber-50 to-amber-50',
      iconColor: 'text-amber-600',
      link: 'https://us.fullscript.com/welcome/drawilliams',
      linkText: 'Visit Fullscript'
    },
    {
      icon: CreditCard,
      title: 'Membership Payment Support',
      description: 'Convenient payment processing for existing MDVIP members through our secure RepeatMD platform.',
      color: 'from-stone-50 to-amber-50',
      iconColor: 'text-amber-600',
      linkText: 'RepeatMD Portal (Coming Soon)',
      disabled: true
    }
  ];

  const medicareServices = [
    {
      icon: FileText,
      title: 'Advance Care Planning Support',
      description: 'Comprehensive assistance with advance care planning to ensure your wishes are documented and honored.'
    }
  ];

  return (
    <AnimatedPage className="min-h-screen">
      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-br from-stone-50 via-stone-50 to-stone-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="text-4xl md:text-5xl font-bold text-stone-900 mb-6 text-gradient-ocean">
              Specialized Services
            </h1>
            <div className="h-1 w-24 bg-gradient-to-r from-amber-500 via-amber-500 to-orange-500 mx-auto mb-6 shimmer"></div>
            <p className="text-xl text-stone-700 leading-relaxed">
              Advanced therapies and comprehensive services designed to optimize your health
              and well-being at every stage of life.
            </p>
          </div>
        </div>
      </section>

      {/* Empty - All services content removed */}

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-stone-600 to-stone-600">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Ready to Get Started?
          </h2>
          <p className="text-xl text-stone-50 mb-8 leading-relaxed">
            Join MDVIP to access our comprehensive specialized services and
            experience personalized healthcare excellence.
          </p>
          <a
            href="https://www.mdvip.com/doctors/allisonwilliamsmd"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button className="bg-stone-50 text-stone-700 hover:bg-stone-50 font-bold px-10 py-6 text-lg shadow-xl hover:shadow-2xl transition-all duration-300 hover-lift-strong hover-glow-rainbow border-glow-slate btn-premium">
              Enroll in MDVIP
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </a>
        </div>
      </section>
    </AnimatedPage>
  );
};

export default Services;
